module.exports = __webpack_public_path__ + "static/architectural-comingsoon-d6905622159fa00aacf68901e0a0f5c2.jpg";